import { IDisposable } from '../../types/disposable';
import { PermissionKey } from '../types';
import { TrackableSet } from './trackable-set';

export interface IPermissionStore<TPermissionKey extends PermissionKey> {
    has(key: TPermissionKey): boolean;
    add(...permissions: TPermissionKey[]): void;
    remove(...permissions: TPermissionKey[]): void;
    clear(): void;
    subscribe(listener: (args: { values: TPermissionKey[] }) => void): IDisposable;
}

export interface IPermissionStoreOptions<TPermissionKey extends PermissionKey> {
    onChange?: (args: { values: TPermissionKey[] }) => void;
}

const defaultPermissionChangeHandler = () => {
    /** Default permission change handler */
};

export function createPermissionStore<TPermissionKey extends PermissionKey>(options: IPermissionStoreOptions<TPermissionKey> = {}): IPermissionStore<TPermissionKey> {
    const availablePermissions = new TrackableSet<TPermissionKey>();
    const { onChange = defaultPermissionChangeHandler } = options;
    availablePermissions.on('change', onChange);
    return {
        has(key: TPermissionKey) {
            return availablePermissions.has(key);
        },
        add(...permissions: TPermissionKey[]) {
            permissions.forEach(p => availablePermissions.add(p));
        },

        remove(...permissions: TPermissionKey[]): void {
            permissions.forEach(p => availablePermissions.delete(p));
        },
        clear() {
            availablePermissions.clear();
        },
        subscribe(listener: (args: { values: TPermissionKey[] }) => void) {
            availablePermissions.on('change', listener);
            return {
                dispose() {
                    availablePermissions.off('change', listener);
                }
            };
        }
    };
}
